import React, { useRef,useEffect, useCallback } from "react";

function useInterval(callback, delay) {
  const savedCallback = useRef();
  const intervalId = useRef(null);

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    if (delay !== null) {
      function tick() {
        savedCallback.current();
      }

      const id = setInterval(tick, delay);
      intervalId.current = id;

      return () => clearInterval(id);
    }
  }, [delay]);

  // Rückgabefunktion zum Stoppen
  const clear = useCallback(() => {
    if (intervalId.current !== null) {
      clearInterval(intervalId.current);
    }
  }, []);

  return clear;
}


  export default useInterval;